/* global require */
import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
const Cookies = require('js-cookie');

class Component extends BaseComponent {
    componentDidMount() {
        this.start();
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.logged_in && !this.props.logged_in) {
            this.start();
        } else if (!nextProps.logged_in && this.props.logged_in) {
            this.stop();
        }

        return false;
    }

    componentWillUnmount() {
        this.stop();
    }

    render() {
        return (<user />);
    }

    start = () => {
        let luserCookie = Cookies.get('luser');

        if (luserCookie) {
            this.timer = setInterval(() => {
                luserCookie = Cookies.get('luser');
                if (!luserCookie) {
                    setTimeout(() => { this.props.refresh(); }, 10000);
                }
            }, 300000);
        }
    }

    stop = () => {
        if (this.timer) {
            clearInterval(this.timer);
        }
    }
}

const mapStateToProps = (state) => ({
    logged_in: state.user && state.user.logged_in,
});

const mapDispatchToProps = (dispatch) => ({
    refresh: () => dispatch({ type: 'user:refresh' }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
